export const BASE_URL:string = import.meta.env.VITE_APP_BACKEND_URL;
export const CHAT_BOT_URL = import.meta.env.VITE_CHAT_BOT;
export const DAILY_REMINDER_URL = import.meta.env.VITE_APP_URL;
// User Registration endpoints
export const endPoints = {
  CUSTOMSIGNIN: '/user',
  USERS:"users",
  VERIFICATION_CODE: '/user/email-code-verification',
  USER_ROUTE: '/user',
  USER_SOCIAL_SIGN_IN: '/user/social-signin',
  USER_VERIFICATION_CODE: '/user/code',
  ALM_TOKEN: '/alm/learner-token',
  ALM_REFRESH_TOKEN:"/alm/refresh-learner-token",
  BILLING_CYCLE: '/stripe/prices',
  STRIPE_REDIRECT_URI: '/stripe/checkout/session',
  CHECK_USER_SUBSCRIPTION: '/user/subscriptions', //get user subscription
  CHECK_CUSTOMER_SUBSCRIPTION: '/stripe/customer-portal/session', //get user subscription
  ALM_API: import.meta.env.VITE_APP_ALM_URL,
  PRIME_API_VER: 'primeapi/v2',
  ALL_LEARNING_PROGRAMS: 'learningObjects',
  FNDAMENTAL_PROGRAM: 'learningObjects',
  ALM_BADGES: 'badges',
  ALM_ENROLLMENTS: 'enrollments',
  ALM_BOOKMARK: 'bookmark',
  ALM_BOARDS: 'boards',
  ALM_POSTS: 'posts',
  CATALOGS: 'catalogs',
  ALM_PROGRAM_UNENROLLMENT: 'enrollments',
  ALM_USERS: 'users',
  ALM_CALENDAR: 'calendar',
  ALM_PLAYER_PATH: 'app/player?lo_id=',
  CREATE_DISCUSSION_BOARD: '/alm/dicsussion/board',
  CREATE_DISCUSSION_BOARD_POST: '/alm/dicsussion/post',
  ALM_COMMENTS: 'comments',
  ALM_REPLY: 'replies',
  ALM_COMMENT_VOTE: 'vote',
  VITE_FAQ: import.meta.env.VITE_FAQ,
  QUARTER_DETAIL: '/user/quarter-details',
  DAILY_REMINDER: '/user/daily-reminders',
  ADD_ALM_POST_ID: '/alm/notes/post',
  ADD_ALM_COMMENTS_ID: '/alm/notes/comments',
  ADD_ALM_NOTES: (id: any) => `/comments/${id}/replies`,
  ALM_NOTES_REPLY: '/alm/notes/reply',
  GET_ALM_NOTES_COMMENTS: 'alm/notes-mapping',
  GET_ALM_REPLIES_NOTES: (id: any) => `/comments/${id}/replies`,
  ALM_NOTES_MAPPING: '/alm/notes-mapping',
  ALM_NOTES_SEQUENCE: '/alm/notes/set-sequence',
  ALM_UPDATE_NOTES_SEQUENCE: (commentId: any) => `/alm/notes/update-latest/${commentId}`,
  ADD_DAILY_REMINDER_BOOKMARK: '/user/bookmark/daily-reminder',
  DELETE_DAILY_REMINDER_BOOKMARK: (id: any) => `/user/bookmark/daily-reminder/${id}`,
  DEVICE_DETAIL: '/user/device-details',
  COURSE_COMPLETE: '/alm/course/complete',
  GET_LO_RESOURCE_GRADE: (id: any) => `/loResourceGrades/${id}`,
  READ_FILE: '/alm/read-file-content',
  EXERCISE_COURSE: '/alm/exercise',
  ALM_USER_SETTING: '/userSettings',
  USER_SETTING: '/user/setting',
  ALM_USERS_CALENDAR: (id: any) => `/users/${id}/calendar?filter.allSessions=false`,
  AVATAR_URL_UPDATE: "/user/avatarUrl-update",
  ALM_AVATAR_DELETE: "/avatar",
  SOCIAL_LINKS: "/user/socialMediaUrls",
  DELETE_NOTES_REPLY: "/alm/notes/reply/deleted",
  exerciseMultipleCourse: "/alm/exercise-multiple-course",
  POLICY_AND_TERM_CONDITION: "/user/htmlTemplates",
  activeLanguages: "/user/active-languages",
  POST_COMMENTS:"/alm/posts/comments",
  POST_REPLIES:"/alm/comment/replies",
  STATIC_VARIABLES:"static-variables/locale",
  SUBSCRIPTION_VARIABLES:"subscription-variables/locale",
  REGISTRATION_COMPLETED:"/user/registration-completed",
  MEETINGCOMPLETE:'/alm/live-class/complete',
  USER_AVATARURL_UPDATE:'/user/avatarUrl-update',
  STORAGE_TO_BAKEND:'/user/corporate/cognito',
  USER_CONFIRMATION: "/user/cognitodetails",
  RESEND_INVITE: "/user/resendinvite",
  EVENTS: "events",
  CHAINLIT_TOKEN_GENERATION:"/user/chainlit/access-token",
  USER_CORPORATE_ACCOUNT_ACTIVE_STATUS: "/user/token-validity",

};

export const ALM_URL = `${endPoints.ALM_API}/${endPoints.PRIME_API_VER}`;
export const VEDIO_PLAYER_URL = `${endPoints.ALM_API}/${endPoints.ALM_PLAYER_PATH}`;
export const VITE_FAQ_URL = `${endPoints.VITE_FAQ}`;
export const DATA_CATION_URL = import.meta.env.VITE_DATA_CATION_URL;
export const VITE_STATIC_CONTENT_URL = import.meta.env.VITE_STATIC_CONTENT;
export const APPCUES_GET_EVENT = import.meta.env.VITE_APPCUES_GET_EVENT_URL;
export const APPCUES_ACCOUNT_ID = import.meta.env.VITE_APPCUES_ACCOUNT_ID;
